import "./HarvestOptionModal.scss"
import React from "react"
import { Box } from "@mui/material"
import Modal from "./Modal"
import Text from "./Text"
import { SUPPORTED_WALLETS } from "src/constants"
import { find } from "lodash"
import { useTranslation } from "react-i18next"
import { useActiveWeb3React } from "src/hooks"
import lockOneWeek from "../assets/icons/lock-1-week.svg"
import { useIsMobile } from "src/hooks/useIsMobile"
import { useAction } from "src/hooks/useAction"
import { actions } from "src/state/xFer"
import { HarvestMode } from "src/state/xFer/types"
import { formatNumber } from "src/utils/parseStringToBigNumber"
import { useVaultsApr } from "src/pages/Stake/hooks/useVaultsApr"
import { BigNumber } from "ethers"

interface Props {
  open: boolean
  onClose: () => void
  harvest: () => Promise<void>
  harvestMode: HarvestMode
  harvestAmount: BigNumber
}

function HarvestOptionModal({
  onClose,
  open,
  harvest,
  harvestMode,
  harvestAmount,
}: Props) {
  const { connector } = useActiveWeb3React()
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const vaultsApr = useVaultsApr()

  const earnMaxApr =
    vaultsApr.length === 0
      ? 0
      : Math.max(...vaultsApr.map((x) => parseFloat(x.apr)))

  const openDepositModal = useAction(actions.setOpenedDepositModal, {
    defaultSelectedPool: null,
    harvest,
    lockAmount:
      harvestMode === HarvestMode.Vault
        ? harvestAmount
        : harvestAmount.mul(60).div(100),
  })

  const handleHarvest = async () => {
    try {
      await harvest()
      onClose()
    } catch (e) {
      console.error(e)
    }
  }

  const handleOpenDepositModal = () => {
    openDepositModal()
    onClose()
  }

  const walletIcon = find(SUPPORTED_WALLETS, ["connector", connector])?.icon

  return (
    <>
      <Modal title={t("Choose Harvest Option")} open={open} onClose={onClose}>
        <Box
          display="flex"
          alignItems="stretch"
          textAlign="center"
          mt={1}
          mb={2}
          flexDirection={isMobile ? "column" : "row"}
          gap={2}
        >
          <Box
            sx={{ cursor: "pointer", ["&:hover"]: { opacity: 0.8 } }}
            onClick={handleHarvest}
            className="option-tile"
          >
            <img src={walletIcon} alt="icon" height={30} />
            <Text>{t("To my wallet")}</Text>
            <Text size="small" color="dim">
              {t("Harvest FER rewards to your wallet")}
            </Text>
          </Box>
          <Box
            sx={{ cursor: "pointer", ["&:hover"]: { opacity: 0.8 } }}
            onClick={handleOpenDepositModal}
            className="option-tile"
          >
            <img src={lockOneWeek} alt="icon" height={30} />
            <Text>{t("Stake into xFer vault")}</Text>
            <Text size="small" color="dim">
              {t("Earn up to ")}
              {`${formatNumber(earnMaxApr, 2, 2)}% `}
              {t("APR when you lock your FER tokens in vault")}
            </Text>
            <Text
              gradient="gradient-blue"
              mt={1}
              mb={3}
              p="4px"
              borderRadius="10px"
              display="inline-block"
            >
              {t("Recommended")}
            </Text>
          </Box>
        </Box>
      </Modal>
    </>
  )
}

export default HarvestOptionModal
